import styled from 'styled-components';
import { color, spacing } from './';

export const Input = styled.input`
   padding: ${spacing(0.25)} ${spacing(0.5)};
   border-radius: ${({ theme }) => theme.borderRadius};
   border: 1px solid ${({ theme }) => theme.separator};
   flex: 1;
   outline: none;
   appearance: none;

   &:focus,
   &:active {
      outline: none;
      border-color: ${color('grey', 'dark')};
   }

   &:disabled {
      background: ${({ theme }) => theme.disabledBackground};
      color: ${({ theme }) => theme.disabledColor};
      cursor: not-allowed;

      &:hover {
         box-shadow: none;
      }
   }
`;

export const InputSearch = styled(Input)`
   padding: ${spacing(0.5)} ${spacing(2)} ${spacing(0.5)} ${spacing(2)};
   border-radius: 4px;
`;

export const Error = styled.div`
   color: ${({ theme }) => theme.error};
   margin-top: ${({ theme }) => theme.spacing(0.25)};
`;
